/**
 * Created by Administrator on 2018/9/18.
 */
//bus.js
import Vue from 'vue'
export default new Vue()



//////////////////
// WEBPACK FOOTER
// ./static/js/bus.js
// module id = null
// module chunks = 